// generated from 12_741 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const campaignOrCanvasWithTagRetargetFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("campaign_or_canvas_with_tag_retarget_filter"),
  comparison_key: z.enum([
    "7", // 11_117 (87.25%)
    "8", // 1_624 (12.75%)
  ]),
  display_name: z.enum([
    "opened email", // 5_159 (40.49%)
    "directly opened push notification", // 3_812 (29.92%)
    "clicked email", // 1_386 (10.88%)
    "clicked content card", // 919 (7.21%)
    "clicked in-app message", // 365 (2.86%)
    "viewed content card", // 357 (2.80%)
    "opened email (other opens)", // 226 (1.77%)
    "clicked in-app message button 2", // 196 (1.54%)
    "clicked in-app message button 1", // 133 (1.04%)
    "viewed in-app message", // 127 (1.00%)
    "clicked shortened sms link", // 28 (0.22%)
    "dismissed content card", // 24 (0.19%)
    "opened email (machine opens)", // 7 (0.05%)
    "replied to sms", // 1 (0.01%)
    "read WhatsApp message", // 1 (0.01%)
    // Not sampled, but offered by CampaignOrCanvasWithTagRetargetFilter.allowed_interactions
    // (feature flipper dependent; names from TRIGGER_ONLY_PAST_TENSE_DISPLAY_NAME_BY_INTERACTION).
    "viewed banner",
    "clicked banner",
    "dismissed banner",
    "clicked tracked WhatsApp link",
    "clicked tracked LINE link",
    "clicked tracked KakaoTalk link",
  ]),
  // undefined: 3_995 (31.36%), defined 8_746 (68.64%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: z.union([
      // string samples: 12_740 (99.99%)
      common.objectId,
      // object samples: 1 (0.01%)
      z.object({
        sms_keyword_id: common.objectId,
        tag_id: common.objectId,
      }),
    ]),
    // undefined: 12_740 (99.99%), defined 1 (0.01%)
    pre_filter_value: z
      .object({
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
